import { render } from "./CardsFrame.vue?vue&type=template&id=2e8ed14d"
import script from "./CardsFrame.vue?vue&type=script&lang=js"
export * from "./CardsFrame.vue?vue&type=script&lang=js"
script.render = render

export default script